import { LawMatrixSpinner } from '../../ui-base';

interface Props {
  text?: string;
}

export function LoadingIndicator(props: Props) {
  const { text } = props;

  return (
    <div className="flex items-center gap-2">
      <div data-testid="spinner-container">
        <LawMatrixSpinner />
      </div>
      <span
        className="dark:text-dark-text text-lawmatrix-purple"
        data-testid="text-container"
      >
        {text ?? 'Loading...'}
      </span>
    </div>
  );
}

export default LoadingIndicator;
